import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import NotFoundTemplate from './not-found.template';
import ResponseErrorTemplate from './response-error.template';
import { SearchResponseResult } from '@cewe-designsystem/util_onsitesearch-api-client/types/SearchTypes';
import { OnsiteSearchComponent } from '../../cwc-onsite-search';

/**
 * Definition of  parameters that the template needs to work.
 */
interface MessagesTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: OnsiteSearchComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const MessagesTemplate: FunctionalComponent<MessagesTemplateProps> = ({ controller }) => {
  // no response
  if (!controller.searchResponse) {
    return <ResponseErrorTemplate controller={controller} textResources={controller.textResources} />;
  }

  const resultCount = Object.values(controller.searchResponse.results)
    .filter((result) => Object.prototype.hasOwnProperty.call(result, 'hits'))
    .reduce((acc: number, result: SearchResponseResult) => acc + Number(result?.hits.length ?? 0), 0);

  if (resultCount === 0) {
    return <NotFoundTemplate query={controller.originalSearchQuery} textResources={controller.textResources} />;
  }
};

export default MessagesTemplate;
